import { Injectable } from '@angular/core';
import { UserDataService } from '../services/user-data.service';
import { ReportSaveService } from './report-save.service';
import { MongoService } from '../services/mongo.service';

@Injectable({
  providedIn: 'root'
})
export class UnregisteredUsersReportService {

  constructor(
    public userDataService: UserDataService,
    private savingService: ReportSaveService,
    private mongoService: MongoService
  ) { }

  public async generateReport() : Promise<void> {
    try {
      const allUsersData = await this.userDataService.getAllExistingUsersData();
      const unregisteredUsersData = await this.getUnregisteredUsers(allUsersData);
      const allUsersContactsData = await this.mongoService.getAllUsersContactsData();
      const preparedData = this.mergeByUserEmail(unregisteredUsersData, allUsersContactsData);

      const reportData = this.generateReportContent(preparedData);
      this.save(reportData);
    } catch(e) {
      console.warn(e);
    }
  }

  private async getUnregisteredUsers(usersData: Array<any>) : Promise<Array<any>> {
    const usersWithoutOrder: Array<any> = [];
    usersData.forEach(d => {
      if (!d.registered) {
        usersWithoutOrder.push(d);
      }
    });
    return usersWithoutOrder;
  }

  private generateReportContent(rankingArray: Array<any>) : Array<Array<any>> {
    const result: Array<Array<any>> = [];
    result.push(this.generateReportHeader());
    result.push(['']);
    let iterator = 1;
    rankingArray.forEach(u => {
      result.push([
        u.userEmail,
        u.companyName, 
        u.firstName, 
        u.lastName, 
        u.phoneNumber, 
        u.voivodeship,
        u.streetName,
        u.buildingNumber,
        u.city,
        u.postalCode
      ]);
      iterator++;
    });
    iterator = 1;


    // sortowanie po województwie (indeks 5)
    const header = result[0];
    const emptyRow = result[1];
    const dataRows = result.slice(2);

    dataRows.sort((a, b) => {
      const aVal = (a[5] || '').toString().toLowerCase();
      const bVal = (b[5] || '').toString().toLowerCase();
      return aVal.localeCompare(bVal, 'pl');
    });

    return [header, emptyRow, ...dataRows];


    // return result;
  }

  private generateReportHeader() : Array<string> {
    return [
      'Adres email',
      'Nazwa firmy', 
      'Imię', 
      'Nazwisko', 
      'Nr telefonu', 
      'Województwo',
      'Ulica',
      'Numer',
      'Miejscowość',
      'Kod'
    ];
  }

  private save(data: Array<Array<any>>) : void {
    this.savingService.saveXlsxReport(data, 'niezarejestrowani.xlsx', 'Raport')
  }

  /**
 * Łączy dane z dwóch tablic po userEmail.
 * @param {Array<Object>} baseArr  - pierwsza tablica (ta z polami punktów/pozycji)
 * @param {Array<Object>} detailsArr - druga tablica (ta z danymi adresowymi)
 * @returns {Array<Object>} nowa tablica obiektów z polami: userEmail + dane z drugiej tablicy
 */
  mergeByUserEmail(baseArr:any, detailsArr:any) {
    const wantedFields = [
      'firstName',
      'lastName',
      'companyName',
      'nipCode',
      'phoneNumber',
      'streetName',
      'buildingNumber',
      'city',
      'postalCode',
      'voivodeship'
    ];

    // Mapowanie: email(lowercase) -> obiekt szczegółów
    const detailsMap = new Map(
      (detailsArr || []).map((d:any) => [(d.userEmail || '').toLowerCase(), d])
    );

    return (baseArr || []).map((b:any) => {
      const key = (b.userEmail || '').toLowerCase();
      const d:any = detailsMap.get(key);

      // Zawsze zwracamy userEmail z pierwszej tablicy
      const merged:any = { userEmail: b.userEmail || '' };

      // Każde wymagane pole: z drugiej tablicy albo pusty string
      for (const f of wantedFields) {
        merged[f] = d && d[f] != null ? d[f] : '';
      }

      return merged;
    });
  }
}
